import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const handleMobileNavigate = () => {
    setMenuOpen(false);
  };

  const handleCheckDealClick = () => {
    window.gtag?.('event', 'nav_check_deal_click', {
      destination: '/deal-checker',
    });
    handleMobileNavigate();
  };

  useEffect(() => {
    if (window.location.hostname === '127.0.0.1') return undefined;
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setMenuOpen(false);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header style={{
      backgroundColor: '#222',
      color: '#fff',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap'
    }}>
      <div style={{ margin: 0 }}>
        <Link to="/" onClick={handleMobileNavigate}>
          <img
            src="https://meshumimages.blob.core.windows.net/websiteimages/1.png"
            alt="Meshum Logo"
            style={{ height: '40px', objectFit: 'contain' }}
          />
        </Link>
      </div>

      {isMobile && (
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            background: 'none',
            border: 'none',
            color: '#fff',
            fontSize: '1.5rem',
            cursor: 'pointer'
          }}
        >
          ☰
        </button>
      )}

      {(menuOpen || !isMobile) && (
        <nav style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: '1rem',
          width: isMobile ? '100%' : 'auto',
          marginTop: isMobile ? '1rem' : 0
        }}>
          <Link to="/" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Home</Link>
          <Link to="/insights/best-deals" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Best Deals</Link>
          <Link to="/deal-checker" onClick={handleCheckDealClick} style={{ color: '#fff' }}>Deal Checker</Link>
          {user?.email ? (
            <>
              <Link to="/saved" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Saved Cars</Link>
              <Link to="/savedsearches" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Saved Searches</Link>
              <span style={{ color: '#aaa' }}>{user.email}</span>
              <button
                onClick={handleLogout}
                style={{
                  backgroundColor: '#444',
                  color: '#fff',
                  border: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Login</Link>
              <Link to="/register" onClick={handleMobileNavigate} style={{ color: '#fff' }}>Register</Link>
            </>
          )}
        </nav>
      )}
    </header>
  );
}

export default Header;
